import { render, staticRenderFns } from "./CategorySelect.vue?vue&type=template&id=7125bdf2&scoped=true&"
import script from "./CategorySelect.vue?vue&type=script&lang=js&"
export * from "./CategorySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7125bdf2",
  null
  
)

export default component.exports